class BlockNotMissed {
  constructor() {
    this._init();
  }

  _init() {
    const sidebar_not_missed = document.querySelector(
      '[data-open-sidebar-not-missed]'
    );
    const sidebar_not_missed_button = document.querySelectorAll(
      '[data-open-sidebar-not-missed-button]'
    );

    if (sidebar_not_missed) {
      sidebar_not_missed.addEventListener(
        'click',
        this._toggleSidebar.bind(this)
      );
    }
    if (sidebar_not_missed_button) {
      sidebar_not_missed_button.forEach((buton) => {
        buton.addEventListener('click', this._toggleSidebar.bind(this));
      });
    }
  }

  _toggleSidebar() {
    const sidebar_not_missed = document.getElementById('sidebar-not-missed');
    if (sidebar_not_missed) {
      sidebar_not_missed.classList.toggle('open');

      if (sidebar_not_missed.classList.contains('open')) {
        document.body.classList.add('sidebar-open');
      } else {
        document.body.classList.remove('sidebar-open');
      }
    }
  }

  _hideSidebar() {
    const sidebar_not_missed = document.getElementById('sidebar-not-missed');
    if (sidebar_not_missed && sidebar_not_missed.classList.contains('open')) {
      sidebar_not_missed.classList.remove('open');
      document.body.classList.remove('sidebar-open');
    }
  }
}

export const blockNotMissed = new BlockNotMissed();
